/**
 * @flow
 * @relayHash 040b0e185008667f56ad55f7e1f0d823
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type GradesAdminQueryResponse = {|
  +master: ?{| |};
|};
*/


/*
query GradesAdminQuery {
  master {
    ...Grades_master
  }
}

fragment Grades_master on Master {
  allGrades(first: 10) {
    edges {
      node {
        id
        name
        code
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GradesAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Grades_master",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "GradesAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "GradesAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              }
            ],
            "concreteType": "GradeConnection",
            "name": "allGrades",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GradeEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Grade",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "code",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allGrades{\"first\":10}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query GradesAdminQuery {\n  master {\n    ...Grades_master\n  }\n}\n\nfragment Grades_master on Master {\n  allGrades(first: 10) {\n    edges {\n      node {\n        id\n        name\n        code\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/master/__generated__/GradesAdminQuery.graphql.js